import { beHttp } from './beHttp';

/**
 * "Voy a trabajar" de la psicóloga frente a un feriado (aviso de feriados de la Agenda) — vive en
 * psiplatform-be (`/api/feriados`). Silencioso: si falla, el aviso sigue funcionando igual.
 */
export async function getFeriadosTrabaja(): Promise<string[]> {
  const res = await beHttp.get<{ trabaja?: string[] }>('/api/feriados/decisiones', undefined, {
    showErrorToast: false,
  });
  return res?.trabaja ?? [];
}

export async function marcarFeriadoTrabajo(date: string): Promise<void> {
  await beHttp.post(`/api/feriados/${date}/trabajo`, undefined, { showErrorToast: false });
}
